const routes = {
  login: 'auth/login',
  logout: 'auth/logout',
  forgetPassword: 'users/forgetPassword',
  resetPassword: 'users/resetPassword',
  changePassword: 'users/changePassword',
};

export default routes